import { render, staticRenderFns } from "./approval-list.vue?vue&type=template&id=ba364a96&scoped=true&"
import script from "./approval-list.vue?vue&type=script&lang=ts&"
export * from "./approval-list.vue?vue&type=script&lang=ts&"
import style0 from "./approval-list.vue?vue&type=style&index=0&id=ba364a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba364a96",
  null
  
)

export default component.exports